/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const BlurryVisionIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M49.2 14.7c-1.5-.2-2.9-.4-4.4-.5-.3 0-.5-.2-.7-.4-.9-1.6-2-3.1-3.4-4.4-1.4-1.4-2.9-2.6-4.6-3.5-10.5-6.1-23.9-2.5-30 8-.1.3-.4.4-.7.4-1.5.1-2.9.3-4.4.5-.6.1-.8.3-.8.8l.3 2.1c.1.1.3.3.5.3.6 0 .9.5 1 1 .4 1.4.9 2.8 1.3 4.3v.5c-.1 2.5.2 5.1.9 7.5 2.9 9.3 11.5 15.5 21.2 15.5.4 0 1.1-.1 1.7-.1.3 0 .5-.1.8-.1C39.3 45 47.6 35.1 47.1 23.7c0-.3 0-.5.1-.8.3-1 .5-1.9.8-2.9l.6-1.5c.1-.2.3-.3.6-.4.3 0 .6-.3.6-.6.1-.6.2-1.2.2-1.8.1-.7-.1-.9-.8-1zM24.1 4.1C32.2 3.7 38.4 7.3 43 14h-.8c-4.1-.1-8.1.4-12.1 1.3-1 .2-2.1.6-3.1.8-1.4.3-2.9.3-4.3-.1-4.8-1.4-9.9-2.1-14.9-1.9h-.4c3.5-6 9.8-9.8 16.7-10zM6.9 16c1.5-.3 3-.4 4.5-.6v.1c2.3 0 4.5.3 6.7.9.8.3 1.5.7 2.2 1.2.4.3.6.7.6 1.2 0 .2 0 .3.1.5-.2 0-.4.2-.5.4-1.5 2.4-5.6 3.3-5.7 3.3-.3.1-.6.4-.6.7 0 .4.3.7.7.7h.2c.2 0 3.7-.8 5.8-3-.2 1.5-.9 3-1.9 4.2-1.1 1.3-2.7 2.2-4.4 2.5-1.8.4-3.8.3-5.6-.1-2.4-.4-4.2-2.4-4.4-4.8-.2-1.4-.3-2.9-.3-4.3s1.1-2.7 2.6-2.9zm20.4 29.3C16 46.5 5.8 38.3 4.6 26.9h.1c.7 1.2 1.8 2 3.2 2.2 3 1 6.4.9 9.3-.4 2.4-1 4.3-3 5.1-5.5.3-.9.7-1.9 1.1-2.8.1-.2.2-.5.4-.6.8-.8 2.1-.9 2.9-.1.3.4.6.9.8 1.4.5 1.1.8 2.3 1.3 3.4 1.2 2.6 3.6 4.4 6.5 4.9 3 .8 6.2.4 8.9-.9.7-.3 1.3-.9 1.6-1.6-1.1 9.7-8.8 17.4-18.5 18.4zM45.5 24c-.4 1.9-1.8 3.4-3.7 3.8-2.7.9-5.6.7-8.2-.4-1.6-.8-2.9-2.1-3.6-3.8-.5-1.4-.8-2.8-.7-4.3 0-1.1.6-2 1.6-2.5 1.5-.7 3.2-1.1 4.8-1.2 1-.1 2.1-.1 3.5-.2 1 .1 2.4.2 3.8.4.8.1 1.6.5 2.2 1.1.3.4.5.8.6 1.3.2 2 .1 3.9-.3 5.8z' />
			<path d='M26.4 29.5c-3.7 0-6.9 2.4-8 5.9v.2c0 .4.3.7.7.7.3 0 .6-.2.7-.5.9-2.9 3.6-4.8 6.6-4.8 3 0 5.6 1.9 6.5 4.8.1.4.5.6.9.5.4-.1.6-.5.5-.9-1.1-3.5-4.3-5.9-7.9-5.9zM37.5 23s-4.2-.9-5.6-3.3c-.2-.3-.6-.4-1-.2s-.5.6-.3 1c1.8 2.9 6.4 4 6.6 4h.2c.3 0 .6-.2.7-.6.1-.4-.2-.8-.6-.9z' />
		</svg>
	)
}

export default BlurryVisionIcon
